<template>
    <div>
        <h3 class="page-header">Auszug aus der Referenzliste</h3>
        <v-layout>
            <v-flex xs12 sm8 offset-sm2>
                <v-container fluid v-bind="{ [`grid-list-${size}`]: true }">
                    <v-layout row wrap>
                        <v-flex
                        xs12 sm12 md6 lg4
                        v-for="item in content"
                        :key="item.title"
                        style="padding: 10px;"
                        >
                            <div class="z-depth-1" style="height: 100%">
                                <v-card style="height: 100%">
                                    <v-card-media :src="item.titlepicture" height="200px"></v-card-media>
                                    <v-card-text class="mh-100" style="height: 100%">
                                        <h4 class="card-title">{{item.title}}</h4>
                                            <v-data-table
                                                :items="item.body"
                                                hide-actions
                                                hide-headers
                                                class="elevation-1"
                                            >
                                                <template slot="items" slot-scope="props">
                                                <td>{{ props.item.head }}</td>
                                                <td class="text-xs-right">{{ props.item.text }}</td>
                                                </template>
                                            </v-data-table>
                                    </v-card-text>
                                </v-card>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import card from '@/components/Card';
    import cardHeader from '@/components/CardHeader';
    import cardBody from '@/components/CardBody';
    import Media from '@/components/Media';
    import MediaImage from '@/components/MediaImage';
    import MediaBody from '@/components/MediaBody';
    export default {
        components: {
            'Card': card,
            'CardHeader': cardHeader,
            'CardBody': cardBody,
            Media,
            MediaImage,
            MediaBody
        },
        data (){
            return {
                headers: [
                    {
                        text: 'Dessert (100g serving)',
                        align: 'left',
                        sortable: false,
                        value: 'name'
                    },
                    { text: 'Calories', value: 'calories' }
                ],
                content: [
                    {
                        title: "AIRBUS Operations GmbH BHKW I",
                        titlepicture: require('../assets/AIR_BHKWI/BHKWI.jpg'),
                        body: [
                            {head: "Aggregat", text: "Jenbacher JMS 612 GS-N.LC"},
                            {head: "Elektrische Leistung", text: "1.998kW"},
                            {head: "Thermische Auskopplung", text: "2.200kW"},
                            {head: "Inbetriebnahme", text: "Okt. 2010"},
                            {head: "Leistungsumfang optiWatt", text: "Alle Phasen HOAI (funktionale Ausschreibung) für Anlagentechnik"}
                        ]
                    },
                    {
                        title: "AIRBUS Operations GmbH BHKW II",
                        titlepicture: require('../assets/AIR_BHKWII/BHKWII.jpg'),
                        body: [
                            {head: "Aggregat", text: "2 Stück MWM TCG 2032 V16"},
                            {head: "Elektrische Leistung", text: "2 x 4.300 kW"},
                            {head: "Thermische Auskopplung", text: "2 x 5.000 kW"},
                            {head: "Wärmespeicher", text: "2 x 610 m³"},
                            {head: "Inbetriebnahme", text: "Feb. 2013"},
                            {head: "Leistungsumfang optiWatt", text: "Alle Phasen HOAI (funktionale Ausschreibung) für Anlagentechnik"}
                        ]
                    },
                    {
                        title: "Stadtwerke Glückstadt GmbH BHKW Tegelgrund",
                        titlepicture: require('../assets/GLU_Tegelgrund/tegelgrund.jpg'),
                        body: [
                            {head: "Aggregat", text: "MTU ME 3042 L3"},
                            {head: "Elektrische Leistung", text: "357 kW"},
                            {head: "Thermische Auskopplung", text: "519 kW"},
                            {head: "Inbetriebnahme", text: "Sep. 2009"},
                            {head: "Wärmespeicher", text: "80 m³"}
                        ]
                    },
                    {
                        title: "Stadtentwässerung Itzehoe BHKW Klärwerk",
                        titlepicture: require('../assets/ITZ_Klaerwerk/klaerwerk.jpg'),
                        body: [
                            {head: "Aggregat", text: "MTU MB3066L4"},
                            {head: "Elektrische Leistung", text: "192 kW"},
                            {head: "Thermische Auskopplung", text: "214 kW"},
                            {head: "Inbetriebnahme", text: "Nov. 2011"},
                            {head: "Wärmespeicher", text: "50m³"},
                            {head: "Leistungsumfang optiWatt", text: "Alle Phasen HOAI (funktionale Ausschreibung) für Anlagentechnik"}
                        ]
                    },
                    {
                        title: "Stadtwerke Itzehoe GmbH BHKW Klinikum",
                        titlepicture: require('../assets/ITZ_Klinikum/klinikum.jpg'),
                        body: [
                            {head: "Aggregat", text: "MTU 20V4000 L62"},
                            {head: "Elektrische Leistung", text: "1.944 kW"},
                            {head: "Thermische Auskopplung", text: "2.324 kW"},
                            {head: "Wärmespeicher", text: "300 m³ horizontal"},
                            {head: "Inbetriebnahme", text: "Aug. 2012"},
                            {head: "Leistungsumfang optiWatt", text: "Alle Phasen HOAI (funktionale Ausschreibung) für Anlagentechnik"}
                        ]
                    },
                    {
                        title: "Stadtwerke Itzehoe GmbH BHKW Klosterforst",
                        titlepicture: require('../assets/ITZ_Klosterforst/klosterforst.jpg'),
                        body: [
                            {head: "Aggregat", text: "MTU 20V4000 L62"},
                            {head: "Elektrische Leistung", text: "1.944 kW"},
                            {head: "Thermische Auskopplung", text: "2.324 kW"},
                            {head: "Wärmespeicher", text: "2 x 160m³ (horizontal)"},
                            {head: "Inbetriebnahme", text: "Feb. 2010"},
                            {head: "Leistungsumfang optiWatt", text: "Alle Phasen HOAI (funktionale Ausschreibung) für Anlagentechnik"}
                        ]
                    },
                    {
                        title: "Stadtwerke Wedel GmbH BHKW Heinestraße",
                        titlepicture: require('../assets/WED_Heinestraße/heinestrasse.jpg'),
                        body: [
                            {head: "Aggregat", text: "MTU 12V400 GS E3042L9"},
                            {head: "Elektrische Leistung", text: "357 kW"},
                            {head: "Thermische Auskopplung", text: "545 kW"},
                            {head: "Inbetriebnahme", text: "2019"},
                            {head: "Wärmespeicher im Gebäude", text: "2 x 30m³"},
                            {head: "Leistungsumfang optiWatt", text: "Alle Phasen HOAI (funktionale Ausschreibung) für Anlagentechnik"}
                        ]
                    },
                    {
                        title: "Stadtwerke Wedel GmbH BHKW Langenkamp",
                        titlepicture: require('../assets/WED_Langenkamp/langenkamp.jpg'),
                        body: [
                            {head: "Aggregat", text: "MTU 16V4000 GS"},
                            {head: "Elektrische Leistung", text: "1999 kW"},
                            {head: "Thermische Auskopplung", text: "2050 kW"},
                            {head: "Inbetriebnahme", text: "2018"},
                            {head: "Wärmespeicher", text: "2 x 160m³"},
                            {head: "Leistungsumfang optiWatt", text: "Alle Phasen HOAI (funktionale Ausschreibung) für Anlagentechnik"}
                        ]
                    },
                    {
                        title: "Stadtwerke Steinburg GmbH iKWK-Anlage HKW Klosterforst",
                        titlepicture: require('../assets/STE_Klosterforst/klosterforst.png'),
                        body: [
                            {head: "Elektrische Leistung BHKW II", text: "ca. 2 MW"},
                            {head: "Thermische Auskopplung BHKW II",
                              text: "ca. 3 MW (mit 3. Abgaswärmetauscher auf Brennwertbetrieb und Abluftnutzung)"},
                            {head: "Kesselleistung", text: "ca. 2x1,3 MW"},
                            {head: "PtH Elektrokessel", text: "ca. 1,4 MW"},
                            {head: "Wärmespeicher", text: "2.500 m³"},
                            {head: "Kältespeicher", text: "400m³"},
                            {head: "Wärmepumpe NH3 (zweistufig)", text: "ca. 0,6MW el / 1,8 MW th (Quelle: div.+ Außenluft)"},
                            {head: "Ausschreibung und Baubeginn", text: "2025"},
                            {head: "Inbetriebnahme", text: "Ende 2026"},
                            {head: "Leistungsumfang optiWatt",
                              text: "Alle Phasen HOAI (funktionale Ausschreibung) für Anlagentechnik"}
                        ]
                    }
                ]
            };
        }
    };
</script>

<style scoped>
.page-header {
  margin-top: 30px;
  text-align: center;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/subpages/reference.vue